import { useConnectionStatusStore } from './connection-status.store'

/**
 * Returns the current network status and last order poll success status.
 */
export function useConnectionStatus() {
  const networkStatus = useConnectionStatusStore(state => state.networkStatus)
  const lastOrderPollSuccess = useConnectionStatusStore(state => state.lastOrderPollSuccess)

  return {
    networkStatus,
    lastOrderPollSuccess,
  }
}
